<template>
    <div class="newsbulletins">
        <div>
            <div class="col-md-10 mt-2 mb-4">
                <h1 class="pstitle">News</h1>
            </div>
        </div>
        <div class="row align-items-md-stretch" v-if="Bulletins.news.length">
            <template v-for="(bulletin, index) in this.Bulletins.news" :key="index">
                <news-card :newsid="bulletin.newsid" :headline="bulletin.headline" :body="bulletin.body" :posted="bulletin.posted" :brand="bulletin.brand"></news-card>
            </template>
            <div>
                <pagination v-model="this.Bulletins.currentPage" :records="this.Bulletins.totalItems" :per-page="this.Bulletins.pageSize" @paginate="getNextBulletins" aria-label="News Pagination"/>
            </div>
        </div>
        <div v-else>
            No news articles have been posted. Check again later.
        </div>
    </div>
</template>
<script>
    import NewsCard from "../atoms/NewsCard.vue";
    import axios from 'axios'
    import getEndPoint, { newsAPI } from '../../constants/api.config'
    import Pagination from 'v-pagination-3'

    export default {
        name: "NewsBulletins",
        props: ["PrimaryFilter"],
        components: {
            NewsCard,
            Pagination
        },
        data() {
            return {
                Bulletins: {
                    totalItems:"",
                    currentPage:"",
                    pageCount:"",
                    pageSize:"",
                    news:[]
                }
            }
        },
        methods: {
            getBulletins(data) {
                let bt= this.Bulletins;
                bt.totalItems=data.totalCount;
                bt.currentPage=data.page;
                bt.pageCount=data.pageCount;
                bt.pageSize=data.pageSize??10;
                let b = [];
                data.data.forEach(element => {
                    b.push(
                        {
                            newsid:element.newsID,
                            headline: element.headline,
                            body: element.body,
                            posted: element.postDate,
                            brand:element.brand
                        }
                    );
                });

                bt.news=b;
                return bt;
            },

            getNextBulletins(event)
            {
                this.getBulletinsData(event);
            },
            getBulletinsData(pageNumber)
            {
                let searchFilters= "";
                if(this.PrimaryFilter!=null && this.PrimaryFilter.type!=undefined && this.PrimaryFilter.type!="")
                {
                    searchFilters = this.PrimaryFilter.type=="brand"? "Brand=":(this.PrimaryFilter.type=="dealer"?"DealerLocationID=":"");
                    axios.get(getEndPoint(newsAPI) + searchFilters + this.PrimaryFilter.key+"&PageSize="+this.Bulletins.pageSize+"&PageNo="+pageNumber)
                    .then((response) => (
                        this.Bulletins = this.getBulletins(response.data)
                    ))
                    .catch((error) => console.log(error));
                }
            }
        },
        mounted() {
            this.getBulletinsData(1);
        },
        watch: { 
            PrimaryFilter: function() { 
            this.getBulletinsData(1);
            }
        }
    };
</script>